/**
 * AB Hero & Spotlight Component
 */

class ABHeroSpotlight extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.swiper');
    if (!this.container) return;

    this.init();
  }

  init() {
    const spacing = parseInt(this.container.dataset.spacing) || 30;

    const options = {
      loop: true,
      speed: 1000,
      spaceBetween: spacing,
      slidesPerView: 1.2,
      centeredSlides: false,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: spacing * 0.5
        },
        550: {
          slidesPerView: 2,
          spaceBetween: spacing * 0.7
        },
        750: {
          slidesPerView: 3,
          spaceBetween: spacing * 0.8
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: spacing
        },
        1600: {
          slidesPerView: 5,
          spaceBetween: spacing
        },
        1920: {
          slidesPerView: 6,
          spaceBetween: spacing
        }
      }
    };

    if (typeof Swiper !== 'undefined') {
      this.swiper = new Swiper(this.container, options);
    } else {
      console.warn('Swiper.js not found for AB Hero & Spotlight');
    }

    this.initATC();
  }

  initATC() {
    const atcButtons = this.querySelectorAll('button.ab-book-card__atc-btn');
    atcButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart(btn);
      });
    });
  }

  async addToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('loading');

    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        // Successful add
        console.log('Product added to cart:', data);

        // Dispatch event for other cart components (standard Shopify pattern)
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: data
        }));

        // Update Header Cart Count
        this.updateHeaderCartCount();

        // Trigger theme's cart notification if it exists
        const cartNotification = document.querySelector('cart-notification');
        if (cartNotification) {
          cartNotification.renderContents(data);
        }

        // Optional: show a quick success message on button
        const originalText = btn.querySelector('span').innerText;
        btn.querySelector('span').innerText = 'Added!';
        setTimeout(() => {
          btn.querySelector('span').innerText = originalText;
        }, 2000);

      } else {
        console.error('Error adding to cart:', data.description);
        alert(data.description);
      }
    } catch (error) {
      console.error('AJAX Add to Cart failed:', error);
    } finally {
      btn.classList.remove('loading');
    }
  }

  async updateHeaderCartCount() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();

      const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
      cartCountBubbles.forEach(bubble => {
        const countSpan = bubble.querySelector('span[aria-hidden="true"]');
        if (countSpan) {
          countSpan.innerText = cart.item_count;
        }
        bubble.classList.remove('hidden');
      });

      // If no bubble exists (first item added), we might need to refresh the whole icon
      if (cartCountBubbles.length === 0) {
        // This is more complex, usually requiring a section render API call
        // For now, we rely on the theme's cart notification
      }
    } catch (error) {
      console.error('Failed to update cart count:', error);
    }
  }
}

customElements.define('ab-hero-spotlight', ABHeroSpotlight);
